import styled, { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import PartnerUI from 'hb-builder/components/BuilderComponents/block/Partners/components/Partner/components/PartnerUI';
import { PARTNERS_LOGOS } from 'hb-builder/components/BuilderComponents/block/Partners/components/Partner/constants';
import { partnersImageRecommendedSize } from 'hb-builder/components/BuilderComponents/constants/imageSizes';
import ImageSetter from 'hb-builder/components/common/ImageSetter';
import type { PartnersItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/partnersItemAttributes';

import type { PartnersSliderItem } from '..';

interface SliderCardProps extends PartnersItemAttributes {
  item: PartnersSliderItem;
}

const SliderCard = ({
  item,
  logoBackground,
  onClickCallBack,
  onDoubleClickCallBack,
  openInNewTab,
  partnerImage,
  partnerImageAlt,
  partnerImageUrl,
  subdomainNetworkUrl,
  withImageSetter,
}: SliderCardProps) => (
  <PartnerUIWrapper
    bg={logoBackground}
    data-testid="slider-card-wrapper"
    onClick={() => onClickCallBack?.(item)}
    onDoubleClick={(e) => onDoubleClickCallBack?.(e, item)}
  >
    <PartnerShadowWrapper>
      <PartnerUI
        index={(item.index || 0) % PARTNERS_LOGOS.length}
        key={item.id}
        isLoadingSrc={item.attributes?.isLoadingSrc}
        openInNewTab={openInNewTab}
        padding={{ _: 2, m: 3 }}
        partnerImage={partnerImage}
        partnerImageAlt={partnerImageAlt}
        // we do not want to send partnerImageUrl if we are in the Builder
        partnerImageUrl={
          !withImageSetter && partnerImageUrl ? partnerImageUrl : undefined
        }
        subdomainNetworkUrl={subdomainNetworkUrl}
      />
    </PartnerShadowWrapper>
    {withImageSetter && (
      <ImageSetter
        attributeName="partnerImage"
        item={item}
        imageSize={partnersImageRecommendedSize}
      />
    )}
  </PartnerUIWrapper>
);

export default SliderCard;

const PartnerUIWrapper = styled(Box).attrs(() => ({
  pb: '6px',
  pt: 1,
}))``;

const PartnerShadowWrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  minHeight: 112,
  width: '100%',
}))`
  ${({ theme }) => css`
    border-radius: ${theme.themeVariables.globalBorderRadius}px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  `}
`;
